"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/Columns` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Columns = createSVGIcon(
  <path
    d="M20.643 1.786H3.357c-.868 0-1.571.703-1.571 1.571v17.286c0 .868.703 1.571 1.571 1.571h17.286c.868 0 1.571-.703 1.571-1.571V3.357c0-.868-.703-1.571-1.571-1.571ZM1.786 6.5h20.428M12 6.5v15.714M1.786 14.357h20.428"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Columns",
  {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24",
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
